// extracted by mini-css-extract-plugin
export default {"RecoveryPasswordSecondStepForm__note":"RecoveryPasswordSecondStepForm_RecoveryPasswordSecondStepForm__note__3llLA"};